export default __webpack_public_path__ + "media/audios/novochat_ring2-dacd3066.mp3";